<template>
  <div id="app">
    <!-- Hide header and footer for dashboard routes -->
    <app-header
      v-if="!isDashboardRoute"
      :branding-image="deptLogo"
      app-title="PHL Eviction Diversion"
    >
      <tabs-nav
        slot="tabs-nav"
        :links="navLinks"
      />
      <mobile-nav
        slot="mobile-nav"
        :links="navLinks"
      />
      <!-- <button
        v-if="!$store.getters['auth/isAuthenticated']"
        slot="right-nav"
        class="button is-primary is-small"
        style="margin-top: -10%;"
        @click.prevent="login"
      >
        <i
          class="fa fa-solid fa-user"
          style="margin-right: 3%;"
        /> Sign-in
      </button>
      <button
        v-if="!$store.getters['auth/isAuthenticated']"
        slot="right-nav"
        class="button is-info is-small"
        style="margin-top: -10%; margin-left: 5px;"
        @click.prevent="forgotPassword"
      >
        <i
          class="fa fa-solid fa-key"
          style="margin-right: 3%;"
        /> Forgot password?
      </button> -->
      <a
        v-if="$store.getters['auth/isAuthenticated']"
        slot="right-nav"
        href="/login"
        class="button is-primary is-small"
        style="color:white; margin-top: -10%;"
      ><b>{{ $store.getters["auth/userInfo"].name }}</b></a>
      <button
        v-if="$store.getters['auth/isAuthenticated']"
        slot="right-nav"
        class="button is-danger is-small"
        style="margin-top: -10%; margin-left: 2%"
        @click.prevent="signOut"
      >
        <i
          class="fa fa-solid fa-user"
          style="margin-right: 3%;"
        /> Sign-out
      </button> 
    </app-header>
    <main class="content" :class="{ 'dashboard-mode': isDashboardRoute }">
      <router-view />
    </main>
    <app-footer
      v-if="!isDashboardRoute"
      :is-sticky="true"
      :links="navLinks"
    />
  </div>
</template>
<script>
import logo from '@/assets/DPD BELL logo_w.png';
export default {
  data() {
    return {
      deptLogo: {
        src: logo,
        alt: 'Philadelphia Department of Planning and Development logo',
        width: "190px",
      },
      navLinks: [
        {
          href: "Home",
          text: "Home",
        },
        {
          href: "About",
          text: "About",
        },
        {
          href: "FAQ",
          text: "FAQ",
        },
        {
          href: "ResourcesPage",
          text: "Resources",
        },
        {
          href: "Status",
          text: "Status",
        },
      ],
    };
  },
  computed: {
    isDashboardRoute() {
      return this.$route.path.startsWith('/dashboard') || this.$route.path == "/login";
    },
  },
  async created() {
    await this.$store.dispatch("auth/loadTokenFromStorage");
  },
  // before mount prints the user info
  beforeMount() {
    if (this.$store.getters["auth/isAuthenticated"]) {
      console.log("User is authenticated");
    } else {
      console.warn("No user info, not authenticated");
    }
    console.log("User info:", this.$store.getters["auth/userInfo"]);
  },
  mounted() {
    // Skip Google Translate setup if on dashboard route
    if (this.isDashboardRoute) {
      return;
    }

    const browser = navigator.userAgent;
    const isMobile = /mobi/i.test(browser);
    const translateNavLinkId = `google_translate_element_${
      isMobile ? "mobile" : "desktop"
    }`;

    const navId = isMobile ? "mobile-menu" : "tabs-nav";
    const navElement = document.getElementById(navId);

    if (navElement) {
      const element = document.createElement("a");
      element.className = "no-js";
      element.id = translateNavLinkId;
      navElement.append(element);
    }
  },
  methods:{
    async login() {
      await this.$store.dispatch("auth/signIn");
    },
    async signOut() {
      await this.$store.dispatch("auth/signOut");
    },
    async forgotPassword() {
      await this.$store.dispatch("auth/forgotPassword");
    },
  },
};
</script>
<style lang="scss">
@import "./assets/scss/main.scss";

#google_translate_element {
  max-height: 40px !important;
  background-color: transparent !important;
}
#google_translate_element > *,
#google_translate_element a,
.goog-te-menu-value > * {
  color: black !important;
  background-color: white !important;
}
.goog-te-banner-frame {
  top: 112px !important;
}
#google_translate_element a {
  padding: 0 !important;
}

main.content{
  margin-top: 145px !important;
}

/* Remove margin for dashboard mode (login and dashboard pages) */
main.content.dashboard-mode {
  margin-top: 0 !important;
  background: white;
  min-height: 100vh;
}

body {
  min-height: auto !important;
}

a{
  word-break: break-word;
}
</style>
